import { render, staticRenderFns } from "./ObjectiveData.vue?vue&type=template&id=3ca7ff5a&scoped=true"
import script from "./ObjectiveData.vue?vue&type=script&lang=js"
export * from "./ObjectiveData.vue?vue&type=script&lang=js"
import style0 from "./ObjectiveData.vue?vue&type=style&index=0&id=3ca7ff5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca7ff5a",
  null
  
)

export default component.exports